import customAxios from "./axios";
import CONFIG from "../../config";

export const paymentRefundRequestCreate = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/PaymentRefunds/Create", payload)
    .then((res) => {
      return res;
    });
};


export const getAllPaymentTypes = () => {
  return customAxios
    .get(CONFIG.apiURL + "/Payments/GetAllPaymentTypes")
    .then((res) => {
      return res;
    });
};